package data.models

import kotlinx.serialization.Serializable

@Serializable
data class LogoutData(
    val refreshToken: String?,
)


